function Loading() {
  return (
    <div className="flex items-center justify-center ">
      <div className="h-40 w-40 animate-spin rounded-full border-t-4 border-b-4 border-gray-800" />
    </div>
  )
}

export default Loading
